module.exports = __webpack_public_path__ + "static/media/window.dd14e1ae.svg";